import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, setSchoolsSearchCriteria, toggleDrawerMobileFilterSearch} from '../../actions';
import Button from '@material-ui/core/Button';
import IconSearch from '@material-ui/icons/Search';
import '../../assets/scss/searchBar.css';
import SchoolsSearchBarMenuItem from "./SchoolsSearchBarMenuItem";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_schoolssearchbar';
import {withLastLocation} from 'react-router-last-location';

class SchoolsSearchBar extends Component {
    menuWrapperRef = React.createRef();
    submenuTypeRef = React.createRef();
    submenuProgrammeRef = React.createRef();
    submenuDegreeRef = React.createRef();

    state = {
        submenuTypeVisible: false,
        submenuProgrammeVisible: false,
        submenuDegreeVisible: false,
        type: '',
        programme: '',
        degree: '',
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside, false);

        // Get the taxonomies terms
        this.props.getSchoolsTypes();
        this.props.getSchoolsProgrammes();
        this.props.getSchoolsDegrees();
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside, false);
    }

    componentDidUpdate(prevProps, prevState) {
        const {type, programme, degree} = this.state;
        const {lastLocation, schools} = this.props;

        if (prevState.type !== type || prevState.programme !== programme || prevState.degree !== degree) {
            this.props.setSchoolsSearchCriteria(
                (type === '0') ? 0 : type,
                (programme === '0') ? 0 : programme,
                (degree === '0') ? 0 : degree,
            );

            setTimeout(() => {
                this.props.history.push(this.props.translate('routes.schools'));
            }, 250);
        }
    }

    /**
     * If the user click outside the menu, automatically close the submenus.
     */
    handleClickOutside = e => {
        if (this.menuWrapperRef && !this.menuWrapperRef.current.contains(e.target)) {
            if (this.state.submenuTypeVisible || this.state.submenuProgrammeVisible || this.state.submenuDegreeVisible) {
                this.setState({
                    submenuTypeVisible: false,
                    submenuProgrammeVisible: false,
                    submenuDegreeVisible: false
                });
            }
        }
    };

    /**
     * Show or hide a submenu.
     */
    handleSubmenu = (e, data) => {
        e.preventDefault();

        const link = e.currentTarget;
        let menu = link.dataset.menu;

        switch (menu) {
            case 'type':
                this.setState({
                    submenuTypeVisible: !this.state.submenuTypeVisible,
                    submenuProgrammeVisible: false,
                    submenuDegreeVisible: false,
                });
                break;
            case 'programme':
                this.setState({
                    submenuTypeVisible: false,
                    submenuProgrammeVisible: !this.state.submenuProgrammeVisible,
                    submenuDegreeVisible: false,
                });
                break;
            case 'degree':
                this.setState({
                    submenuTypeVisible: false,
                    submenuProgrammeVisible: false,
                    submenuDegreeVisible: !this.state.submenuDegreeVisible
                });
                break;
            default:
                break;
        }
    };

    handleSubmenuItemClick = (e) => {
        e.preventDefault();

        const link = e.currentTarget;

        const taxonomy = link.getAttribute('data-taxonomy');

        switch (taxonomy) {
            case 'type':
                this.setState({
                    submenuTypeVisible: false,
                    [taxonomy]: link.getAttribute('data-id')
                });
                break;
            case 'programme':
                this.setState({
                    submenuProgrammeVisible: false,
                    [taxonomy]: link.getAttribute('data-id')
                });
                break;
            case 'degree':
                this.setState({
                    submenuDegreeVisible: false,
                    [taxonomy]: link.getAttribute('data-id')
                });
                break;
            default:
                break;
        }
    };

    handleClickMobileSearch = (e) => {
        e.preventDefault();

        this.props.toggleDrawerMobileFilterSearch();
        this.props.history.push(this.props.translate('routes.schools'));
    };

    render() {
        const {types, programmes, degrees, taxonomiesLoading} = this.props.schools;
        const {type, programme, degree} = this.state;

        let menuItemsTypes = [];
        let menuItemsProgrammes = [];
        let menuItemsDegrees = [];

        if (types !== null && !taxonomiesLoading) {
            types.map(term => (
                menuItemsTypes.push(<SchoolsSearchBarMenuItem key={term.term_id} term={term} taxonomy="type" current={this.state.type} handleClick={this.handleSubmenuItemClick}/>)
            ));
        }

        if (programmes !== null && !taxonomiesLoading) {
            programmes.map(term => (
                menuItemsProgrammes.push(<SchoolsSearchBarMenuItem key={term.term_id} term={term} taxonomy="programme" current={this.state.programme} handleClick={this.handleSubmenuItemClick}/>)
            ));
        }

        if (degrees !== null && !taxonomiesLoading) {
            degrees.map(term => (
                menuItemsDegrees.push(<SchoolsSearchBarMenuItem key={term.term_id} term={term} taxonomy="degree" current={this.state.degree} handleClick={this.handleSubmenuItemClick}/>)
            ));
        }

        let nameItemType = '';
        let nameItemProgramme = '';
        let nameItemDegree = '';

        if (type === '0') {
            nameItemType = 'Tous';
        } else if (type !== '') {
            types.forEach((item, index) => {
                if (item.term_id === parseInt(type, 10)) {
                    nameItemType = item.name;
                }
            });
        }

        if (programme === '0') {
            nameItemProgramme = 'Tous';
        } else if (programme !== '') {
            programmes.forEach((item, index) => {
                if (item.term_id === parseInt(programme, 10)) {
                    nameItemProgramme = item.name;
                }
            });
        }

        if (degree === '0') {
            nameItemDegree = 'Tous';
        } else if (degree !== '') {
            degrees.forEach((item, index) => {
                if (item.term_id === parseInt(degree, 10)) {
                    nameItemDegree = item.name;
                }
            });
        }

        return (
            <Fragment>
                <div id="schools-search-bar" className="d-none d-md-block" ref={this.menuWrapperRef}>
                    <div className="inner">
                        <div className="row no-gutters">
                            <div className="col-criteria col-12">
                                <div className="row no-gutters">
                                    <div className="col col-4">
                                        <Button className={classnames('menu', {'active': (type !== '')})} data-menu="type" onClick={this.handleSubmenu}>
                                            <span className="menu-title"><span><Translate id="schools_search_bar.type_ecole" /></span></span>
                                            <span className="menu-subtitle">{nameItemType}</span>
                                            <i className="material-icons">keyboard_arrow_down</i>
                                        </Button>
                                    </div>
                                    <div className="col col-4">
                                        <Button className={classnames('menu', {'active': (programme !== '')})} data-menu="programme" onClick={this.handleSubmenu}>
                                            <span className="menu-title"><span><Translate id="schools_search_bar.programme" /></span></span>
                                            <span className="menu-subtitle">{nameItemProgramme}</span>
                                            <i className="material-icons">keyboard_arrow_down</i>
                                        </Button>
                                    </div>
                                    <div className="col col-4">
                                        <Button className={classnames('menu', {'active': (degree !== '')})} data-menu="degree" onClick={this.handleSubmenu}>
                                            <span className="menu-title"><span><Translate id="schools_search_bar.diplome" /></span></span>
                                            <span className="menu-subtitle">{nameItemDegree}</span>
                                            <i className="material-icons">keyboard_arrow_down</i>
                                        </Button>
                                    </div>
                                </div>
                                <div id="schools-submenu-type" ref={this.submenuTypeRef} className={classnames('submenu', {
                                    'visible': this.state.submenuTypeVisible,
                                    'hidden': !this.state.submenuTypeVisible,
                                })}>
                                    <div className="inner">
                                        <div className="row no-gutters">
                                            <div className="col col-4">
                                                <a href="javascript:;" data-id="0" data-taxonomy="type" onClick={this.handleSubmenuItemClick} className={classnames('', {
                                                    'active': (this.state.type === '' || this.state.type === '0'),
                                                })}>
                                                    <span><Translate id="schools_search_bar.item_all" /></span>
                                                </a>
                                            </div>
                                            {menuItemsTypes}
                                        </div>
                                    </div>
                                </div>
                                <div id="schools-submenu-programme" ref={this.submenuProgrammeRef} className={classnames('submenu', {
                                    'visible': this.state.submenuProgrammeVisible,
                                    'hidden': !this.state.submenuProgrammeVisible,
                                })}>
                                    <div className="inner">
                                        <div className="row no-gutters">
                                            <div className="col col-4">
                                                <a href="javascript:;" data-id="0" data-taxonomy="programme" onClick={this.handleSubmenuItemClick} className={classnames('', {
                                                    'active': (this.state.programme === '' || this.state.programme === '0'),
                                                })}>
                                                    <span><Translate id="schools_search_bar.item_all" /></span>
                                                </a>
                                            </div>
                                            {menuItemsProgrammes}
                                        </div>
                                    </div>
                                </div>
                                <div id="schools-submenu-degree" ref={this.submenuDegreeRef} className={classnames('submenu', {
                                    'visible': this.state.submenuDegreeVisible,
                                    'hidden': !this.state.submenuDegreeVisible,
                                })}>
                                    <div className="inner">
                                        <div className="row no-gutters">
                                            <div className="col col-4">
                                                <a href="javascript:;" data-id="0" data-taxonomy="degree" onClick={this.handleSubmenuItemClick} className={classnames('', {
                                                    'active': (this.state.degree === '' || this.state.degree === '0'),
                                                })}>
                                                    <span><Translate id="schools_search_bar.item_all" /></span>
                                                </a>
                                            </div>
                                            {menuItemsDegrees}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="schools-search-bar-mobile" className="d-md-none">
                    <Button size="medium" className="btn-search m-auto d-md-flex d-lg-none justify-content-center" variant="contained" color="primary" onClick={this.handleClickMobileSearch}>
                        <IconSearch className="icon" />
                        <Translate id="schools_search_bar.button_search_title_mobile" />
                    </Button>
                </div>
            </Fragment>
        )
    }
}

SchoolsSearchBar.propTypes = {
    getSchoolsTypes: PropTypes.func.isRequired,
    getSchoolsProgrammes: PropTypes.func.isRequired,
    getSchoolsDegrees: PropTypes.func.isRequired,
    setSchoolsSearchCriteria: PropTypes.func.isRequired,
    toggleDrawerMobileFilterSearch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    schools: state.schools,
});

export default withRouter(withLastLocation(connect(mapStateToProps, {getSchoolsTypes, getSchoolsProgrammes, getSchoolsDegrees, setSchoolsSearchCriteria, toggleDrawerMobileFilterSearch})(withLocalize(SchoolsSearchBar))));



// WEBPACK FOOTER //
// ./src/features/Schools/components/SearchBar/SchoolsSearchBar.js